import {
  selectBrazeContentCards,
  selectContentCards,
  selectContentCardsLoaded,
  selectHomePageFeedContentCards,
  selectLocalReadsSyncStatus,
  selectLocalReadsVersion,
  selectNewsFeedContentCards,
  selectNotificationCenterSessionId,
  selectNotificationCenterSessionOwnerId,
  selectResolvedNotificationIds,
  selectServerReadNotificationIds,
  selectServerReadStatus,
  selectWebContentCards,
} from './content-cards/content-cards.selectors';
import {
  selectAppPersonalizedOfferGroups,
  selectAppPersonalizedOffers,
  selectAppliedOffers,
  selectCmsOffers,
  selectDiscountAppliedCmsOffer,
  selectEngineOfferListItems,
  selectGuestEngineOfferListItems,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectOfferFeedbackMap,
  selectOffersLoading,
  selectSelectedOffer,
  selectShouldRefetchOffers,
  selectValidAppliedOffers,
} from './offers/offers.selectors';
import {
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAppliedReward,
  selectAppliedRewardsParsed,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectRewardsFeedbackMap,
  selectShouldRefetchRewards,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
} from './rewards/rewards.selectors';
import {
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectLoyaltyUser,
  selectUser,
} from './user/user.selectors';
import {
  selectLoyaltyWalmart,
  selectLoyaltyWalmartUI,
  selectLoyaltyWalmartUILoading,
} from './walmart/walmart.selectors';

export const loyaltySelectors = {
  // Offer actions
  selectAppliedOffers,
  selectCmsOffers,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectIncentivesIds,
  selectOfferFeedbackMap,
  selectGuestEngineOfferListItems,
  selectOffersLoading,
  selectAppPersonalizedOffers,
  selectAppPersonalizedOfferGroups,
  selectSelectedOffer,
  selectEngineOfferListItems,
  selectValidAppliedOffers,
  selectDiscountAppliedCmsOffer,
  selectShouldRefetchOffers,
  // Rewards actions
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedRewardsParsed,
  selectAppliedPoints,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectShouldRefetchRewards,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
  selectAppliedReward,
  selectRewardsFeedbackMap,
  // User actions
  select12DigitSwipeCard,
  selectLoyaltyLoading,
  selectUser,
  selectLoyaltyUser,
  // Walmart UI
  selectLoyaltyWalmartUI,
  selectLoyaltyWalmartUILoading,
  selectLoyaltyWalmart,
  // Content Cards
  selectContentCards,
  selectBrazeContentCards,
  selectNewsFeedContentCards,
  selectHomePageFeedContentCards,
  selectWebContentCards,
  selectContentCardsLoaded,
  selectServerReadNotificationIds,
  selectServerReadStatus,
  selectResolvedNotificationIds,
  selectLocalReadsSyncStatus,
  selectLocalReadsVersion,
  selectNotificationCenterSessionId,
  selectNotificationCenterSessionOwnerId,
};
